import { Label, ListBox, ListBoxItem, Select, SelectPopover, SelectTrigger, SelectValue } from "@heroui/react";

export type SelectOption = {
	value: string;
	label: string;
};

type SelectFieldProps = {
	label?: string;
	options: SelectOption[];
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	isDisabled?: boolean;
	className?: string;
};

const SelectField: React.FC<SelectFieldProps> = ({ label, options, value, onChange, placeholder, isDisabled, className }) => (
	<Select
		className={className}
		selectedKey={value || null}
		onSelectionChange={(key) => onChange(String(key))}
		isDisabled={isDisabled}
		placeholder={placeholder}
	>
		{label ? <Label>{label}</Label> : null}
		<SelectTrigger>
			<SelectValue />
		</SelectTrigger>
		<SelectPopover>
			<ListBox>
				{options.map((option) => (
					<ListBoxItem key={option.value} id={option.value}>
						{option.label}
					</ListBoxItem>
				))}
			</ListBox>
		</SelectPopover>
	</Select>
);

export default SelectField;
